import { FC } from 'react';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';

import { QUESTION_HISTORY_ROW_TEST_IDS } from '../../../../constants/data-testids';
import { TableCell, TableRow } from '../Table/Table';

export const QuestionHistoryRowSkeleton: FC = () => {
  return (
    <TableRow data-testid={QUESTION_HISTORY_ROW_TEST_IDS.SKELETON}>
      <TableCell>
        <div className="flex flex-col gap-2 items-start">
          <Skeleton className="h-[14px] w-full" />
          <Skeleton className="h-[14px] w-2/3" />
        </div>
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
    </TableRow>
  );
};
